module.exports = ".responsive {\n  position: absolute;\n  z-index: 3;\n  width: 100%;\n  max-width: 350px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/generic-filters/generic-filters.component.scss
// module id = ./src/app/shared-components/generic-filters/generic-filters.component.scss
// module chunks = main